// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__l-ez6","profile1":"Profile_profile1__34XYF","photo":"Profile_photo__EUvK3","info":"Profile_info__OJ2QN","stle":"Profile_stle__XMB8C"};